<template>
  <v-container>
    <div>
      <h1>Datensatz Strasseklassierung</h1>
      <p>Dieser Datensatz beinhaltet die Flächen der Strassen und die Angaben zum Abstand und Klasse. Die Fläche kann von der Bauzonenfläche abgezogen werden und damit die Anrechenbarkeit der Bauzone beeinflussen.</p>
      <p><b>Datenquelle</b><br />GIS-Dienstleister / Raumplaner</p>
      <p><b>Format</b><br />Shape-File (.shp) mit allen dazugehörigen formatspezifischen Dateien (.prj, .dbf, .shx, optional .cpg). Alle Dateien müssen in einem ZIP-File komprimiert und hochgeladen werden.<br />Koordinatensystem: Swiss CH1903+ / LV95; EPSG: 2056</p>
          <p>
            <v-simple-table>
            <template v-slot:default>
            <thead>
                <tr>
                <th class="text-left">
                    Name
                </th>
                <th class="text-left">
                    Beschreibung
                </th>
                <th class="text-left">
                    Einheit
                </th>
                </tr>
            </thead>
            <tbody>
                <tr
                v-for="item in attributes"
                :key="item.name"
                >
                <td>{{ item.name }}</td>
                <td>{{ item.desc }}</td>
                <td>{{ item.unit }}</td>
                </tr>
            </tbody>
            </template>
                  </v-simple-table>
          </p>
      <!-- <p>TODO Download Beispieldatensatz</p> -->
    </div>
  </v-container>

</template>

<script>
export default {
  name: 'DocStr',
  data () {
    return {
      attributes: [
        {
          name: 'geom',
          desc: 'Strassenflächen',
          unit: 'Polygon/Multipolygon'
        },
        {
          name: 'klasse',
          desc: 'Bezeichnung der Strassenklassierung.\nZ.B. \'Kantonsstrasse oder Gemeindestrasse\'',
          unit: 'Text (max. 70 Zeichen)'
        },
        {
          name: 'abstand',
          desc: 'Abstand zu der Strassengeometrie in Meter. Standard: 0',
          unit: 'Meter'
        },
        {
          name: 'anrech',
          desc: '(Optionales Attribut) Strassenfläche anrechenbar true/false. Wenn "false" wird diese abgezogen. Standard: false',
          unit: 'Boolean'
        }

      ]
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/docs/DocStr.vue